import type { SuiteExternalRunner } from '../../../../features/test-suites';

export function canRunExternalSuite(args: {
  sourceKind: SuiteExternalRunner['sourceKind'];
  provider: SuiteExternalRunner['provider'];
  repoId: string | null;
  bundleStorageKey: string | null;
  sandboxTemplateId: string | null;
  sandboxActionSlug: string | null;
  targetSandboxV2Environment: string | null;
}): boolean {
  if (args.sourceKind === 'upload') {
    const sandboxV2Playwright = args.provider === 'playwright' && args.targetSandboxV2Environment !== null;
    return Boolean(
      args.bundleStorageKey &&
        (sandboxV2Playwright || (args.sandboxTemplateId && args.sandboxActionSlug))
    );
  }
  return args.repoId !== null;
}

export function externalSuiteSourceLabel(
  runner: Pick<SuiteExternalRunner, 'sourceKind' | 'bundleDigest' | 'repoUrl' | 'repoRef'>
): string {
  if (runner.sourceKind === 'upload') {
    const digest = runner.bundleDigest?.slice(0, 12);
    return digest ? `uploaded bundle · ${digest}` : 'uploaded Playwright bundle';
  }
  return runner.repoRef ?? runner.repoUrl ?? 'GitHub repository';
}

export function externalSuiteRunBlocker(
  runner: Pick<
    SuiteExternalRunner,
    | 'sourceKind'
    | 'provider'
    | 'bundleStorageKey'
    | 'repoUrl'
    | 'sandboxTemplateId'
    | 'sandboxActionSlug'
    | 'targetSandboxV2Environment'
    | 'archivedAt'
  >
): string | null {
  if (runner.archivedAt) return 'This runner is archived';
  if (runner.sourceKind === 'upload' && !runner.bundleStorageKey) {
    return 'Upload a Playwright bundle before running this suite';
  }
  const sandboxV2Playwright =
    runner.provider === 'playwright' && runner.targetSandboxV2Environment !== null;
  if (
    runner.sourceKind === 'upload' &&
    !sandboxV2Playwright &&
    (!runner.sandboxTemplateId || !runner.sandboxActionSlug)
  ) {
    return 'Choose a sandbox template and action before running this suite';
  }
  if (runner.sourceKind === 'github' && !runner.repoUrl?.trim()) {
    return 'Link a GitHub repository before running this suite';
  }
  return null;
}
